import gql from 'graphql-tag';
const name = 'companyFragment';
const fragment = gql`
  fragment ${name} on Company {
    id
    name
    externalIds
    logo {
      url
      id
      baseUrl
    }
    metadata {
      displayName
      description
      shortDescription
    }
    email
    phone
    website
  }
`;

export default {
  name,
  fragment,
};
